import script from "./layout-without-sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./layout-without-sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./layout-without-sidebar.vue?vue&type=style&index=0&id=898a1e6c&lang=less"

const __exports__ = script;

export default __exports__